/* eslint-disable import/no-anonymous-default-export */
export default {
  borderRadius: 7.22,
  backgroundColor: "#E9E9E9",
  padding: 1,
  marginLeft: -1.5,
};
